import { IMembershipObject, IMembershipState } from '../../../types/index'
import {
  IMembershipAction,
  IMembershipFail,
  IMembershipListSuccess,
  IMembershipSuccess,
  ISetActiveMembership
} from '../../actions/membership_request'
import {
  MEMBERSHIP_FAIL,
  MEMBERSHIP_LIST_FAILURE,
  MEMBERSHIP_LIST_REQUEST,
  MEMBERSHIP_LIST_SUCCESS,
  MEMBERSHIP_REQUEST,
  MEMBERSHIP_SUCCESS,
  MEMBERSHIPSUCCES_UPDATE_STATUS,
  MEMBERSHIPSUCCES_UPDATING_STATUS,
  SET_SELECTED_MEMBERSHIP,
  TOGGLE_MEMBERSHIP_MODAL
} from '../../constants/'

const initMembershipState: IMembershipState = {
  items: {},
  isFetching: false,
  lastUpdated: Date.now(),
  rowsPerPage: 10,
  isModalOpen: false,
  updatingStatus: '',
  selectedMembership: null
}

export function membership(state: IMembershipState = initMembershipState, action: IMembershipAction): IMembershipState {
  if (typeof state === 'undefined') {
    return initMembershipState
  }
  switch (action.type) {
    case MEMBERSHIP_LIST_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case MEMBERSHIP_LIST_SUCCESS: {
      const membershipList = (action as IMembershipListSuccess).membershipList
      const items = Object.assign({}, membershipList)
      return Object.assign({}, state, {
        items,
        isFetching: false,
        lastUpdated: Date.now()
      })
    }
    case MEMBERSHIP_LIST_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case MEMBERSHIP_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        items: []
      })
    case MEMBERSHIP_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: (action as IMembershipSuccess).data
      })
    case MEMBERSHIP_FAIL:
      return Object.assign({}, state, {
        isFetching: false,
        error: (action as IMembershipFail).error
      })
    case TOGGLE_MEMBERSHIP_MODAL:
      return Object.assign({}, state, {
        isModalOpen: !state.isModalOpen
      })
    case SET_SELECTED_MEMBERSHIP:
      return Object.assign({}, state, {
        isModalOpen: true,
        selectedMembership: (action as ISetActiveMembership).selectedMembership
      })
    case MEMBERSHIPSUCCES_UPDATING_STATUS:
      return Object.assign({}, state, {
        updatingStatus: MEMBERSHIPSUCCES_UPDATING_STATUS
      })
    case MEMBERSHIPSUCCES_UPDATE_STATUS:
      return Object.assign({}, state, {
        updatingStatus: MEMBERSHIPSUCCES_UPDATE_STATUS,
        items: (action as IMembershipSuccess).data
      })

    default:
      return state
  }
}

export const getMembershipsByIds = (memberships: IMembershipState, membershipIds: string[]): IMembershipObject[] => {
  return Object.values(memberships.items).filter(
    (it: IMembershipObject) => it.id && membershipIds && membershipIds.includes(it.id)
  )
}



// WEBPACK FOOTER //
// ./src/state/reducers/membership_request/index.ts